import * as React from "react";

import useEvent from "@/hooks/use-event";
import { useVenueType } from "@/hooks/use-venue-type";

/**
 * Custom hook that returns the appropriate timezone for schedule display
 * based on venue type. Returns event timezone for onsite/hybrid events,
 * user timezone for virtual events.
 *
 * @returns The timezone string to use for schedule time formatting
 */
export function useScheduleTimezone() {
  const { event } = useEvent();
  const { venue_type } = useVenueType(); // This will fetch venue_type if needed

  return React.useMemo(() => {
    const timezone_user_locale = Intl.DateTimeFormat().resolvedOptions()
      .timeZone;

    // Only use event timezone for onsite or hybrid events
    const shouldUseEventTimezone =
      venue_type === "onsite" || venue_type === "hybrid";

    return shouldUseEventTimezone && event?.standard_timezone
      ? event.standard_timezone
      : timezone_user_locale;
  }, [event?.standard_timezone, venue_type]);
}
